import React from 'react';

import { updateTaskOnServerAction } from 'actions/task';
import { useDatePicker } from 'components/hooks/useDatePicker';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import DateField, { DueDateStyles } from './DateField';

export default function DueDateField({
  dueDate,
  color = null,
  tooltipText,
  isCrossed,
  updateDueDate,
  clearable = true,
  minDate = null,
  isDisabled = false,
}) {
  const openDueDatePicker = useDatePicker(updateDueDate);
  const onClickHandler = (e) => {
    e.stopPropagation();
    if (isDisabled) return;
    openDueDatePicker({ initialDate: dueDate || new Date(), clearable, minDate });
  };

  return (
    <StyledDateField borderColor={color} onClick={onClickHandler} tooltip={tooltipText}>
      {dueDate ? (
        <StyledDatePresentDisplay date={dueDate} isCrossed={isCrossed} />
      ) : (
        <DateField.DateNotPresentDisplay />
      )}
    </StyledDateField>
  );
}

export function NewDueDateField({
  dueDate,
  color = null,
  hoverText,
  isCrossed,
  taskId,
  taskKey,
  dispatch,
  clearable = true,
  minDate = null,
  disableOnClick = false,
}) {
  function updateDueDate(newDueDate) {
    dispatch(
      updateTaskOnServerAction({
        id: taskId,
        key: taskKey,
        updatedData: { dueDate: newDueDate },
      })
    );
  }
  const openDueDatePicker = useDatePicker(updateDueDate);
  const onClickHandler = (e) => {
    if (disableOnClick) return;
    e.stopPropagation();
    openDueDatePicker({ initialDate: dueDate || new Date(), clearable, minDate });
  };

  return (
    <StyledDateField borderColor={color} onClick={onClickHandler} tooltip={hoverText}>
      {dueDate ? (
        <StyledDatePresentDisplay date={dueDate} isCrossed={isCrossed} />
      ) : (
        <DateField.DateNotPresentDisplay />
      )}
    </StyledDateField>
  );
}

const StyledDateField = styled(DateField)`
  ${DueDateStyles}
`;

const StyledDatePresentDisplay = styled(DateField.DatePresentDisplay)`
  ${(props) =>
    props.isCrossed &&
    css`
      text-decoration: line-through;
    `};
`;

// export function BackupDueDateField({ taskDetails, updateTask }) {
//   const onDueDateChange = date => updateTask({ ...taskDetails, dueDate: date }, false);
//   const openDueDatePicker = useDatePicker(onDueDateChange);
//   const onClickHandler = e => {
//     e.stopPropagation();
//     openDueDatePicker();
//   };
//   const detailedStatus = taskDetails.detailedStatus;
//   const dueDate = taskDetails.dueDate;
//   const borderColor = useMemo(() => {
//     return getDueDateColorForSelectedStatus(detailedStatus, Boolean(dueDate));
//   }, [detailedStatus, dueDate]);

//   return (
//     <StyledDateField borderColor={borderColor} onClick={onClickHandler}>
//       {taskDetails.dueDate ? (
//         <DateField.DatePresentDisplay date={taskDetails.dueDate} />
//       ) : (
//         <DateField.DateNotPresentDisplay />
//       )}
//     </StyledDateField>
//   );
// }
DueDateField.propTypes = {
  dueDate: PropTypes.object,
  detailedStatus: PropTypes.string,
  updateDueDate: PropTypes.func.isRequired,
};
